import React from "react";
import { JsIconBox } from "../../components/brand/JsIcon";
import { audiences } from "./data";

/**
 * AudiencesSection — "¿Para quién es Procure?" — 3 cards de público objetivo.
 */
export function AudiencesSection() {
  return (
    <section className="border-b border-gray-200 bg-white" data-testid="landing-audiences-section">
      <div className="container-prose py-20">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <p className="text-xs uppercase tracking-[0.22em] text-brand-coral font-semibold mb-3">¿Para quién es?</p>
          <h2 className="font-serif text-3xl sm:text-4xl text-gray-900 mb-3">
            Pensado para quienes deciden compras públicas.
          </h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {audiences.map(({ iconName, title, body }, idx) => (
            <div
              key={title}
              data-testid={`audience-card-${idx}`}
              className="relative p-7 bg-white border border-gray-200 rounded-sm hover:border-brand-burgundy hover:shadow-md transition-all group"
            >
              <div className="mb-4">
                <JsIconBox name={iconName} size={56} boxSize={80} />
              </div>
              <h3 className="font-serif text-xl text-gray-900 mb-2">{title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
